import axios from 'axios';
import Vue from 'vue'
import qs from 'qs';
//创建一个axios实例

const instance = axios.create({
	baseURL: Vue.prototype.URL_PREFIX + 'irriproject/',
	// baseURL:  'http://localhost:8080/api/irriproject/',
	// baseURL: Vue.prototype.URL_PREFIX + 'irriproject_old/',
	// baseURL:Vue.prototype.URL_PREFIX+'cy/',
    // baseURL: '/api/newslcj/',
	//timeout: 10000,
	timeout: 1000000,
	responseType: 'json',
	headers: {
		'X-Requested-With': 'XMLHttpRequest'
	}

});
axios.interceptors.request.use = instance.interceptors.request.use;
//创建一个表单axios实例
const instancepic = axios.create({
	baseURL: Vue.prototype.URL_PREFIX + 'irriproject/',
	// baseURL: Vue.prototype.URL_PREFIX + 'irriproject_old/',
	// baseURL:Vue.prototype.URL_PREFIX+'cy/',
	//timeout: 10000,
	timeout: 1000000,
	responseType: 'json',
	headers: { 'Content-Type': 'multipart/form-data' }
});
axios.interceptors.request.use = instancepic.interceptors.request.use;

//创建一个测试实例（数据来源于数据采集系统）
const ceshi = axios.create({
	baseURL: '/ceshi/slcj/',
	timeout: 6000,
	responseType: 'json',
	headers: {
		'X-Requested-With': 'XMLHttpRequest'
	}

});
axios.interceptors.request.use = ceshi.interceptors.request.use;

const instance2 = axios.create({
	baseURL: 'http://localhost:8088/static',
	timeout: 6000,
});
axios.interceptors.request.use = instance2.interceptors.request.use;

//-----------------------------------------------------接口定义从这里开始--------------------------------------------------
export const fetchData = () => {
	return instance2.get('data/hospital.geojson').then(res => res.data)
}
//---------- 登录页 ----------
/*
 * 登录接口
 * @param {String} loginname   用户名
 * @param {String} password    密码
 */
export const login = (params) => {
	return instance.post('login.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 版权接口
 */
export const getcopyright = (params) => {
	return instance.post('getcopyright.spring', qs.stringify(params)).then(res => res.data)
}


/*
 * 修改密码接口
 */
export const modifypassword = (params) => {
	return instance.post('modifypassword.spring', qs.stringify(params)).then(res => res.data)
}


//---------- 首页 ----------
/*
 * 地图边界
 * @param {String} userid   用户的userid
 * @param {String} regioncode    行政区划编码
 * @param {String} regionLevel   行政区划级别
 */
export const regionQuery = (params) => {
	return instance.post('region_query.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 首页左侧的查询功能的查询条件
 * @param {String} userid   用户的userid
 */
export const dinnerQuerydataterm = (params) => {
	return instance.post('dinner_querydataterm.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 首页图片上传
 * @param {String} userid  用户的userid {String} fycd  {MultipartFile} picture
 */
export const uploadphoto = (params) => {
	return instancepic.post('uploadphoto.spring', params).then(res => res.data)
}

/*
 * 首页左侧的专题条件
 * @param {String} userid   用户的userid
 */
export const dinnerQuerymapterm = (params) => {
	return instance.post('dinner_querymapterm.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 总数统计
 * @param {String} userid   用户的userid
 * @param {String} regioncode 行政区划编码
 */
//export const dinnerGettotalcount = (params) => {return instance.post('dinner_gettotalcount.spring',qs.stringify(params)).then(res => res.data)}

/*
 * 专题图查询数据查询接口（专题点）
 * @param
 */
export const dinnerQuerymapdata = (params) => {
	return instance.post('dinner_querymapdata.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 餐饮点加载
 * @param {String} userid   用户的userid
 */
export const dinnerGetshortmapdata = (params) => {
	return instance.post('dinner_getshortmapdata.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 餐饮点加载
 * @param {String} userid   用户的userid
 */
//export const stationquery = (params) => {return instance.post('stationquery.spring',qs.stringify(params)).then(res => res.data)}
export const stationquery = (params) => {
	return instance.post('stationquery.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 地图上的详情按钮查询接口
 * @param {String} userid   用户的userid
 * @param {String} datauuid
 * @param {String} resourceid
 */
export const queryMsaterdata = (params) => {
	return instance.post('querymsaterdata.spring', qs.stringify(params)).then(res => res.data)
}

//---------- 运维管理 ----------
//1、数据字典模块
/*
 * 获取所有字典表
 * @param {String} userid   用户的userid
 */
export const queryLayer = (params) => {
	return instance.post('query_layer.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 修改图层
 * @param
 */
export const modifyresourceLayer = (params) => {
	return instance.post('modifyresourcelayer.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 新增图层
 * @param
 */
export const addLayer = (params) => {
	return instance.post('add_layer.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 删除图层
 * @param
 */
export const deleteLayer = (params) => {
	return instance.post('delete_layer.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 查询字段
 * @param {String} token  这个参数目前写死，无用
 * @param {String} resourceid  图层id
 */
export const queryField = (params) => {
	return instance.post('query_field.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 新增字段
 * @param
 */
export const addField = (params) => {
	return instance.post('add_field.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 修改字段
 * @param
 */
export const modifyField = (params) => {
	return instance.post('modify_field.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 删除字段
 * @param {String} id 字段id
 */
export const deleteField = (params) => {
	return instance.post('delete_field.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 修改字段顺序
 * @param {String} ids  字段id拼接的字符串
 * @param {String} resourceid  图层id
 */
export const modifyIndexs = (params) => {
	return instance.post('modify_indexs.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 获取所有关联表，关联字段信息
 * 无参数
 */
export const getTableandFields = (params) => {
	return instance.get('gettableandfields.spring').then(res => res.data)
}
/*
 * 获取字段类型下拉（仅系统参数表有）
 * 无参数
 */
export const getParamtype = (params) => {
	return instance.get('getparamtype.spring').then(res => res.data)
}
/*
 * 查询附表，从表
 * @param {String} mastertbid  主表id
 * @param {String} userid  用户id
 */
export const querySlaveLayer = (params) => {
	return instance.post('query_slave_layer.spring', qs.stringify(params)).then(res => res.data)
}
//2、角色权限模块
/*
 * 通用模板中的查询接口(这里是用于加载角色列表)
 * @param
 */
export const queryData = (params) => {
	return instance.post('query_data.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 获取系统所有菜单
 * 无参数
 */
export const getAllmenu = (params) => {
	return instance.get('getallmenu.spring').then(res => res.data)
}
/*
 * 查询测站最新数据的实时数据
 */
export const queryfloatingframeex = (params) => {
	return instance.post('queryfloatingframeex.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 根据角色id获取菜单
 * @param {String} roleid  角色id
 */
export const queryMenubyroleid = (params) => {
	return instance.post('querymenubyroleid.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 根据角色id修改菜单及字段显示权限
 * @param {String} roleid    角色id
 * @param {String} arrydata  修改数据的拼接
 */
export const modifyMenubyroleid = (params) => {
	return instance.post('modifymenubyroleid.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 添加/修改菜单
 * @param {String} id   菜单id
 * @param {JSONString}  nodedata  节点数据
 */
export const addMenu = (params) => {
	return instance.post('add_menu.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 删除菜单
 * @param {String} id   菜单id
 */
export const deleteMenu = (params) => {
	return instance.post('delete_menu.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 删除菜单
 * @param {String} pid   pid
 * @param {String} roleid   角色id
 */
export const getRolepagebypid = (params) => {
	return instance.post('getrolepagebypid.spring', qs.stringify(params)).then(res => res.data)
}

//----------------------数据采集测试接口----------------------------
/*
 * 查询字段
 * @param {String} resourceid
 * @param {String} userid
 * @param {String} isdataflow
 * @param {String} menuid
 */
export const getTablequeryinfo = (params) => {
	return instance.post('gettablequeryinfo.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 根据resourceid查询表详细信息
 * @param {String} resourceid  表的id
 */
export const getReourcelayerbyid = (params) => {
	return instance.post('getreourcelayerbyid.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 获取单条数据
 * @param {String} resourceid  表的id
 * @param {String} uuid  数据的id
 */
export const queryUserdata = (params) => {
	return instance.post('queryuserdata.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 获取关联字段下拉值
 * @param {String} resourceid  表的id
 */
export const getRefertablefieldinfo = (params) => {
	return instance.post('getrefertablefieldinfo.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 获取联动下拉值
 * @param {String} associatedtable  关联表
 * @param {String} associatedfield  关联字段
 * @param {String} associatedvfield  关联显示字段
 * @param {String} prelinkfield  关联上级
 * @param {String} prefieldvalue  关联上级的值
 * @param {String} associatedfieldtype  关联字段类别
 * @param {String} resourceid  字段所在表的资源id
 */
export const linkageQuery = (params) => {
	return instance.post('linkageQuery.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 保存修改表单数据(废弃)
 * @param {String} userid  用户id
 * @param {String} uuid    数据id
 * @param {String} resourceid  表对应id
 * @param {JSONString} data  所有数据
 * @param {String} isdataflow  表格是否为流程表
 */
export const addData = (params) => {
	return instance.post('add_data.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 新增一条表单数据
 * @param {String} userid  用户id
 * @param {String} uuid    数据id
 * @param {String} resourceid  表对应id
 * @param {JSONString} data  所有数据
 * @param {String} isdataflow  表格是否为流程表
 */
export const insertData = (params) => {
	return instance.post('insert_data.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 修改一条表单数据
 * @param {String} userid  用户id
 * @param {String} uuid    数据id
 * @param {String} resourceid  表对应id
 * @param {JSONString} data  所有数据
 * @param {String} isdataflow  表格是否为流程表
 */
export const updateData = (params) => {
	return instance.post('update_data.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 删除数据
 * @param {String} uuid    数据id
 * @param {String} resourceid  表对应id
 */
export const deleteUserdata = (params) => {
	return instance.post('deleteuserdata.spring', qs.stringify(params)).then(res => res.data)
}

//---------- 文件上传 ----------
/*
 * 上传文件
 * @param {String} uuid    附件的uuid（对于餐饮的单个文件上传，前台生成该uuid；对于法律法规此类的多个文件上传，该参数可为空）
 * @param {String} resourceid  表的uuid
 * @param {String} folder_id  附件所在文件夹的uuid（若指定传到哪个文件夹中，该参数不可为空；若不指定，该参数为空，后台自动存入到默认文件夹中）
 * @param {String} dataid  该条记录的uuid
 * @param {String} userid  该用户的uuid
 */
export const fileUpload = (params) => {
	return instance.post('fileupload.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 下载文件
 * @param {String} fileuuid    附件的uuid
 */
export const fileDownload = (params) => {
	return instance.post('filedownload.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 根据数据ID获取附件详细信息
 * @param {String} dataid    该条记录的uuid
 */
export const fileGdatainfo = (params) => {
	return instance.post('filegdatainfo.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 删除单个文件
 * @param {String} datauuid	文件的uuid
 */
export const fileDelete = (params) => {
	return instance.post('filedelete.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 删除数据关联的所有文件
 * @param {String} datauuid 该条记录的uuid
 */
export const fileDeleteall = (params) => {
	return instance.post('filedeleteall.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 文件预览（预览单个附件）
 * @param {String} fileuuid	文件的uuid
 */
export const filePreview = (params) => {
	return instance.post('filepreview.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 文件预览（针对一条数据的所有附件）
 * @param {String} dataid	数据的uuid
 */
export const filePreviewmore = (params) => {
	return instance.post('filepreviewmore.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 获取用户列表
 * @param {String} roleid	该用户的roleid
 * @param {String} truename	该用户的truename
 */
export const getUsersByRoleid = (params) => {
	return instance.post('getUsersByRoleid.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 获取所有用户
 * @param {String} userid	该用户的userid
 */
export const getalluser = (params) => {
	return instance.post('getalluser.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 获取用户对应角色
 * @param {String} userid	该用户的userid
 * @param {String} truename	该用户的truename
 */
export const getRoleByUserid = (params) => {
	return instance.post('getrolebyuserid.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 修改用户对应角色
 * @param {String} userid	用户的userid
 * @param {String} roleids 角色id
 * @param {String} truename	用户的truename
 */
export const modifyrolebyuserid = (params) => {
	return instance.post('modifyrolebyuserid.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 查询组织机构下的用户
 * @param {String} userid	 用户id
 * @param {String} groupid	 组织机构id
 */
export const getusersbygroupid = (params) => {
	return instance.post('getusersbygroupid.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 向员工组织机构关联表中添加数据
 * @param {String} userids	 用户id集合，用英文”,”分隔
 * @param {String} groupid	 组织机构id
 * @param {String} uuid	  该条数据的唯一标识
 */
export const modifygroupuser = (params) => {
	return instance.post('modifygroupuser.spring', qs.stringify(params)).then(res => res.data)
}

/*
 * 删除组织机构所拥有的用户
 * @param {String} refuserid	 用户userid,如多个中间用英文逗号分割
 * @param {String} orgid	 组织机构id
 * @param {String} userid	  操作者的id
 */
export const delEmpgroupref = (params) => {
	return instance.post('del_empgroupref.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 测站管理
 */
export const stationmanagement = (params) => {
	return instance.post('stationmanagement.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *修改站点信息
 */
export const upstationmanagement = (params) => {
	return instance.post('upstationmanagement.spring', qs.stringify(params)).then(res => res.data)
}
/*  * 测站管理
 */
export const getfilepath = (params) => {
	return instance.post('getfilepath.spring', qs.stringify(params)).then(res => res.data)
}
/*  * 测站管理
 */
export const stationbasicdata = (params) => {
	return instance.post('stationbasicdata.spring', qs.stringify(params)).then(res => res.data)
}
/*  * 测站管理
 */
export const getdaylistofyear = (params) => {
	return instance.post('getdaylistofyear.spring', qs.stringify(params)).then(res => res.data)
}
/*  * 测站管理
 */
export const querystationhourdate = (params) => {
	return instance.post('querystationhourdate.spring', qs.stringify(params)).then(res => res.data)
}

/*  * 测站管理
 */
export const stationdateofgroupwater = (params) => {
	return instance.post('stationdateofgroupwater.spring', qs.stringify(params)).then(res => res.data)
}
/*  * 测站管理
 */
export const datelistofdaywater = (params) => {
	return instance.post('datelistofdaywater.spring', qs.stringify(params)).then(res => res.data)
}
/*  * 测站管理
 */
export const getallstationinfo = (params) => {
	return instance.post('getallstationinfo.spring', qs.stringify(params)).then(res => res.data)
}
/*  * 测站管理
 */
export const getavgflowdayreportforms = (params) => {
	return instance.post('getavgflowdayreportforms.spring', qs.stringify(params)).then(res => res.data)
}
/*  *    水位日报表
 */
export const getwaterleveldayreport = (params) => {
	return instance.post('getwaterleveldayreport.spring', qs.stringify(params)).then(res => res.data)
}
/*  *    流量日报表
 */
export const getflowdayreport = (params) => {
	return instance.post('getflowdayreport.spring', qs.stringify(params)).then(res => res.data)
}
/*  *    首页通知
 */
export const getpushmsg = (params) => {
	return instance.post('getpushmsg.spring', qs.stringify(params)).then(res => res.data)
}

/*  * 水位流量检索
 */
export const getdatasearchReport = (params) => {
	return instance.post('getdatasearchReport.spring', qs.stringify(params)).then(res => res.data)
}

/*  * 水位流量检索（肯斯瓦特）
 */
export const getKswtDataReport = (params) => {
	return instance.post('getKswtDataReport.spring', qs.stringify(params)).then(res => res.data)
}

/*  * 地图曲线
*/
export const querywqgraph = (params) => {
	return instance.post('querywqgraph.spring', qs.stringify(params)).then(res => res.data)
}
/*  * 地图实时数据
 */
export const queryrealtime = (params) => {
	return instance.post('queryrealtime.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *地图基本信息
 */
export const stationinfoquery = (params) => {
	return instance.post('stationinfoquery.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *逐日平均水位报表
 */
export const getavgleveldayreportforms = (params) => {
	return instance.post('getavgleveldayreportforms.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *地图折线图
 */
export const waterlevelmonitoring = (params) => {
	return instance.post('waterlevelmonitoring.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *水位月报表
 */
export const getwaterlevelmonthreport = (params) => {
	return instance.post('getwaterlevelmonthreport.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *流量月报表
 */
export const getflowmonthreport = (params) => {
	return instance.post('getflowmonthreport.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *水位流量过程线
 */
export const getwaterbytime = (params) => {
	return instance.post('getwaterbytime.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *多站水位过程线
 */
export const getmswaterbyday = (params) => {
	return instance.post('getmswaterbyday.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *雨量日报表
 */
export const getraindayreport = (params) => {
	return instance.post('getraindayreport.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *雨量月报表
 */
export const getrainmonthreport = (params) => {
	return instance.post('getrainmonthreport.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *逐日降雨量
 */
export const getraindayreportforms = (params) => {
	return instance.post('getraindayreportforms.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *日雨量直方图
 */
export const getraindayhistogram = (params) => {
	return instance.post('getraindayhistogram.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *月雨量直方图
 */
export const getrainmonthhistogram = (params) => {
	return instance.post('getrainmonthhistogram.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *地图浮动框
 */
export const queryfloatingframe = (params) => {
	return instance.post('queryfloatingframe.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *多站雨量直方图
 */
export const getrainmonthhistograms = (params) => {
	return instance.post('getrainmonthhistograms.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *水位图例
 */
export const querywatertablelegend = (params) => {
	return instance.post('querywatertablelegend.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *河流曲线
 */
export const queryrivercurves = (params) => {
	return instance.post('queryrivercurves.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *水位,气象，墒情分类
 */
export const getallstationkind = (params) => {
	return instance.post('getallstationkind.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *测流计算表---计算
 */
export const flowcalculation = (params) => {
	return instance.post('flowcalculation.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *灌区简介--图片
 */
export const irrigationphotos = (params) => {
	return instance.post('irrigationphotos.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *测流计算表--保存
 */
export const saveflowcalculation = (params) => {
	return instance.post('saveflowcalculation.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *测流计算表--校验接口
 */
export const flowmatchcurve = (params) => {
	return instance.get('flowmatchcurve.spring',{params}).then(res => res.data)
}

/*
 *测流计算-测流计算成果清单
 */
export const flowcalculationresultlist = (params) => {
	return instance.post('flowcalculationresultlist.spring', qs.stringify(params)).then(res => res.data)
}
/*
 * 测流计算-实测流量成果表
 *
 */
export const getmeasuredresultstable = (params) => {
	return instance.get('getmeasuredresultstable.spring',{params}).then(res => res.data)
}
/*
 *测流计算-测流计算成果详情
 */
export const flowcalculationresultdetails = (params) => {
	return instance.post('flowcalculationresultdetails.spring', qs.stringify(params)).then(res => res.data)
}

// 测流计算-测流计算-获取最新的一条测流成果数据
export const getnewestmeasuredresult = (params) => {
	return instance.get('getnewestmeasuredresult.spring',{params}).then(res => res.data)
}

/*
 *获取视频监控ip地址    用户名   密码
 */
export const getVideoMonitorsAddresses = (params) => {
	return instance.post('getVideoMonitorsAddresses.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *综合实时数据--查询测站实时在线、故障、今日预警、准报率
 */
export const realtimeStationStateAggregate = (params) => {
	return instance.post('realtimeStationStateAggregate.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *综合实时数据--查询测站数据和设备情况
 */
export const realtimestationaggregate = (params) => {
	return instance.post('realtimestationaggregate.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *综合实时数据--查询测站最近日水位流量数据
 */
export const realtimedayilystationdataaggregate = (params) => {
	return instance.post('realtimedayilystationdataaggregate.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *综合实时数据--返回测站监测的信息种类
 */
export const realtimestationlistaggregate = (params) => {
	return instance.post('realtimestationlistaggregate.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *实时雨情信息--查询测站实时在线、故障、今日预警、准报率
 */
export const querykindsnumberrain = (params) => {
	return instance.post('querykindsnumberrain.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *实时雨情信息--查询测站数据和设备情况
 */
export const stationdateofgrouprain = (params) => {
	return instance.post('stationdateofgrouprain.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *实时雨情信息--查询测站最近日水位流量数据
 */
export const datelistofdayrain = (params) => {
	return instance.post('datelistofdayrain.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *巡详情数量排行
 */
export const patrolrank = (params) => {
	return instance.post('patrolrank.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *巡详情里程排行
 */
export const patrolrankbydistance = (params) => {
	return instance.post('patrolrankbydistance.spring', qs.stringify(params)).then(res => res.data)
}

// /*
//   *巡查详情人园列表
// */
// export const patrolman  = (params) => {return instance.post('patrolman.spring',qs.stringify(params)).then(res => res.data)}
/*
 *巡查详情任务列表
 */
export const patrolregionstatus = (params) => {
	return instance.post('patrolregionstatus.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *巡查详情坐标图片信息
 */
export const patrolmaninfo = (params) => {
	return instance.post('patrolmaninfo.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *巡查详情统计信息
 */
export const patrolmanstatistics = (params) => {
	return instance.post('patrolmanstatistics.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *巡查历史总人数
 */
export const patrolhistory = (params) => {
	return instance.post('patrolhistory.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *巡查历史人园详细信息
 */
export const patrolhistoryinfo = (params) => {
	return instance.post('patrolhistoryinfo.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *获取巡查区域
 */

export const patrolregion = (params) => {
	return instance.post('patrolregion.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *巡查任务权限分配
 */
export const patrolassign = (params) => {
	return instance.post('patrolassign.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *巡查任务分配人员
 */
export const patrolpermission = (params) => {
	return instance.post('patrolpermission.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *巡查任务分配人员
 */
export const fittingcalculation = (params) => {
	return instance.post('fittingcalculation.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *测点计算
 */
export const calculatebenchmark = (params) => {
	return instance.post('calculatebenchmark.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *测点保存
 */
export const updatebenchmark = (params) => {
	return instance.post('updatebenchmark.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *获取组名、测点、要素信息
 */
export const getgroupssensorinfo = (params) => {
	return instance.post('getgroupssensorinfo.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *获取组名、测点、要素信息
 */
export const getgroupssensorinfonew = (params) => {
	return instance.post('getgroupssensorinfonew.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *获取组名、测点、要素信息(肯斯瓦特数据录入)
 */
 export const getgroupssensorinfokswt = (params) => {
	return instance.post('getgroupssensorinfokswt.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *水位流量数据拟合保存
 */
export const savefittingcalculation = (params) => {
	return instance.post('savefittingcalculation.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *查询拟合计算成果
 */
export const fittingcalculationresultlist = (params) => {
	return instance.post('fittingcalculationresultlist.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *查询拟合计算成果
 */
export const deletefitcalculationresult = (params) => {
	return instance.post('deletefitcalculationresult.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *拟合数据详情，用于编辑时点击查看
 */
export const fittingcalculationresultdetails = (params) => {
	return instance.post('fittingcalculationresultdetails.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *测流计算删除
 */
export const deleteflowcalculation = (params) => {
	return instance.post('deleteflowcalculation.spring', qs.stringify(params)).then(res => res.data)
}

/*
 *测流计算方式及页面参数
 */
export const getcomputingmethod = (params) => {
	return instance.post('getcomputingmethod.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *停水操作历史
 */
export const waterstophistory = (params) => {
	return instance.post('waterstophistory.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *删除停水操作历史
 */
export const delwaterstophistory = (params) => {
	return instance.post('delwaterstophistory.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *停水数据查询
 */
export const waterstopquery = (params) => {
	return instance.post('waterstopquery.spring', qs.stringify(params)).then(res => res.data)
}
/*
 *停水处理
 */
export const waterstophandle = (params) => {
	return instance.post('waterstophandle.spring', qs.stringify(params)).then(res => res.data)
}

/*
  水费计收-单价管理
*/
export const getPriceingDataByPeriod = (params) => {
	return instance.post('prices.spring', qs.stringify(params)).then(res => res.data)
}
export const setPeriodPrice = (params) => {
	return instance.post('add_price.spring', qs.stringify(params)).then(res => res.data)
}
export const getPriceingDataByStairstep = (params) => {
	return instance.post('getPriceStair.spring', qs.stringify(params)).then(res => res.data)
}
export const setStairstepPrice = (params) => {
	return instance.post('setPriceStair.spring', qs.stringify(params)).then(res => res.data)
}

/*
  水费计收-缴费
*/
export const getPriceReport = (params) => {
	return instance.post('getPriceReport.spring', qs.stringify(params)).then(res => res.data)
}
export const payPriceReport = (params) => {
	return instance.post('payPriceReport.spring', qs.stringify(params)).then(res => res.data)
}
export const payments = (params) => {
	return instance.post('payments.spring', qs.stringify(params)).then(res => res.data)
}

/*
  加载拟合曲线
*/
export const loadfitcurvelist = (params) => {
	return instance.post('loadfitcurvelist.spring', qs.stringify(params)).then(res => res.data)
}
/*
  获取水位流量表数据和日流量表数据
*/
export const getwaterlevelflowmeterdata = (params) => {
	return instance.post('getwaterlevelflowmeterdata.spring', qs.stringify(params)).then(res => res.data)
}
/*
  调用拟合曲线对水位流量数据进行重新拟合，并重新计算日水位数据
*/
export const fitwaterlevelflowmeterdata = (params) => {
	return instance.post('fitwaterlevelflowmeterdata.spring', qs.stringify(params)).then(res => res.data)
}
/*
  调用拟合曲线对水位流量数据进行重新拟合，并重新计算日水位数据
*/
export const updatedatawarehouse = (params) => {
	return instance.post('updatedatawarehouse.spring', qs.stringify(params)).then(res => res.data)
}
/*
资料查询-查询整编记录
*/
export const getdatawarehouselog = (params) => {
	return instance.post('getdatawarehouselog.spring', qs.stringify(params)).then(res => res.data)
}
/*
资料查询-删除整编记录
*/
export const deletedatawarehouselog = (params) => {
	return instance.post('deletedatawarehouselog.spring', qs.stringify(params)).then(res => res.data)
}

export const realtime_graph = (params) => {
	return instance.post('realtime_graph.spring', qs.stringify(params)).then(res => res.data)
}

/*
施测号数
*/
export const thetestnumlist = (params) => {
	return instance.post('thetestnumlist.spring', qs.stringify(params)).then(res => res.data)
}

/*
获取自记始-终值，并计算平均值
*/
export const selfrecordingvalue = (params) => {
	return instance.post('selfrecordingvalue.spring', qs.stringify(params)).then(res => res.data)
}
/*
实测数据保存
*/
export const savemeasureddata = (params) => {
	return instance.post('savemeasureddata.spring', qs.stringify(params)).then(res => res.data)
}
/*
拟合数据保存
*/
export const savefittingdata = (params) => {
	return instance.post('savefittingdata.spring', qs.stringify(params)).then(res => res.data)
}
/*
拟合计算&资料整编-获取曲线编号清单
*/
export const curvenumberlist = (params) => {
	return instance.post('curvenumberlist.spring', qs.stringify(params)).then(res => res.data)
}
/*
拟合计算&资料整编-获取当前断面正在使用的拟合曲线编号
*/
export const getUseingCurvenum = (params) => {
	return instance.post('getUseingCurvenum.spring', qs.stringify(params)).then(res => res.data)
}
/*
曲线详情
*/
export const getfittinginformation = (params) => {
	return instance.post('getfittinginformation.spring', qs.stringify(params)).then(res => res.data)
}
/*
资料整编-加载拟合曲线详情
*/
export const loadFitCurveDetails = (params) => {
	return instance.post('loadFitCurveDetails.spring', qs.stringify(params)).then(res => res.data)
}
/*
实时水情信息/实时雨情信息/综合实时数据--查询测站实时在线、故障、预警、异常
*/
export const querykindsnumber = (params) => {
	return instance.post('querykindsnumber.spring', qs.stringify(params)).then(res => res.data)
}
/*
查询测站基本信息-用于测站管理模块修改按钮跳转的界面展示
*/
export const querystationmanagement = (params) => {
	return instance.post('querystationmanagement.spring', qs.stringify(params)).then(res => res.data)
}
/*
数据录入-数据拟合
*/
export const dataentryfitting = (params) => {
	return instance.post('dataentryfitting.spring', qs.stringify(params)).then(res => res.data)
}
/*
数据录入-数据保存
*/
export const manualinput = (params) => {
	return instance.post('manualinput.spring', qs.stringify(params)).then(res => res.data)
}
/*
查询水位流量关系曲线的接口
*/
export const querystationrelationcurve = (params) => {
	return instance.post('querystationrelationcurve.spring', qs.stringify(params)).then(res => res.data)
}
/*
定制功能-检测图片查询
*/
export const getdetectionpictures = (params) => {
	return instance.post('getdetectionpictures.spring', qs.stringify(params)).then(res => res.data)
}
/*
定制功能-获取配出合成查询流量数据
*/
export const getsynthesisquery = (params) => {
	return instance.post('getsynthesisquery.spring', qs.stringify(params)).then(res => res.data)
}
/*
逐日流量初整表查询接口
*/
export const getwaterdaystatisticsreportbycz = (params) => {
	return instance.post('getwaterdaystatisticsreportbycz.spring', qs.stringify(params)).then(res => res.data)
}
/*
定制功能-获取日平均流量接口
*/
export const getwaterdaystatisticsreport2 = (params) => {
	return instance.post('getwaterdaystatisticsreport2.spring', qs.stringify(params)).then(res => res.data)
}
/*
定制功能-逐日平均水量表(管道流量计) 20220607
 */
 export const getavgwatervolumereport = (params) => {
	return instance.post('getavgwatervolumereport.spring', qs.stringify(params)).then(res => res.data)
}
/*
定制功能-获取日水情接口
*/
export const getwaterdayreportnew = (params) => {
	return instance.post('getwaterdayreportnew.spring', qs.stringify(params)).then(res => res.data)
}
/*
定制功能-获取流量月报表接口
*/
export const getflowmonthreportcusmade = (params) => {
	return instance.post('getflowmonthreportcusmade.spring', qs.stringify(params)).then(res => res.data)
}
/*
定制功能-逐日流量查询接口
*/
export const getMonthWaterflowdata = (params) => {
	return instance.post('getMonthWaterflowdata.spring', qs.stringify(params)).then(res => res.data)
}
/*
拟合导出
*/
export const fittingdataexport = (params) => {
	return instance.post('fittingdataexport.spring', qs.stringify(params)).then(res => res.data)
}
/*
查找用户能查询的测点
*/
export const getstationofuser = (params) => {
	return instance.post('getstationofuser.spring', qs.stringify(params)).then(res => res.data)
}
/*
分配每个用户在系统中可以看到的站点
*/
export const allotstationofuser = (params) => {
	return instance.post('allotstationofuser.spring', qs.stringify(params)).then(res => res.data)
}
/*
首页弹框的原始报文列表数据
*/
export const getcodeofcpm = (params) => {
	return instance.post('getcodeofcpm.spring', qs.stringify(params)).then(res => res.data)
}
/*
查询测站日雨量月雨量
*/
export const querystationraindata = (params) => {
	return instance.post('querystationraindata.spring', qs.stringify(params)).then(res => res.data)
}
/*
查询原始报文
*/
export const getoriginalmessage = (params) => {
	return instance.post('getoriginalmessage.spring', qs.stringify(params)).then(res => res.data)
}
/*
获取曲线拟合页面最高水位、最低水位默认值
*/
export const getwaterrestrict = (params) => {
	return instance.post('getwaterrestrict.spring', qs.stringify(params)).then(res => res.data)
}
/*
拟合成果录入
*/
export const savefittingresult = (params) => {
	return instance.post('savefittingresult.spring', qs.stringify(params)).then(res => res.data)
}
/*
拟合成果录入--启用
*/
export const updatefittingcurvestate = (params) => {
	return instance.post('updatefittingcurvestate.spring', qs.stringify(params)).then(res => res.data)
}
/*
拟合成果录入--启用
*/
export const getstationlist = (params) => {
	return instance.post('getstationlist.spring', qs.stringify(params)).then(res => res.data)
}
/*
拟合成果录入--立即启用
*/
export const updatefittingcurvestateofnow = (params) => {
	return instance.post('updatefittingcurvestateofnow.spring', qs.stringify(params)).then(res => res.data)
}
/*
拟合成果录入--立即启用（新）2023-07-14 chenbz
*/
export const updatecurvefitstate = (params) => {
	return instance.post('updatecurvefitstate.spring', qs.stringify(params)).then(res => res.data)
}
/*
量测水模板下载
*/
export const exporttemplatedownload = (params) => {
	return instance.post('exporttemplatedownload.spring', qs.stringify(params)).then(res => res.data)
}
/*
获取一体化闸门的基本信息
*/
export const getgatebasicinfo = (params) => {
	return instance.post('getgatebasicinfo.spring', qs.stringify(params)).then(res => res.data)
}
/*
控制一体化闸门
*/
export const controlgatesize = (params) => {
	return instance.post('controlgatesize.spring', qs.stringify(params)).then(res => res.data)
}
/*
一体化闸门基本信息
*/
export const gateinfoquery = (params) => {
	return instance.post('gateinfoquery.spring', qs.stringify(params)).then(res => res.data)
}
/*
一体化闸门-实时数据
*/
export const getgaterealtime = (params) => {
	return instance.post('getgaterealtime.spring', qs.stringify(params)).then(res => res.data)
}
/*
一体化闸门-参数配置信息
*/
export const getgateparamconf = (params) => {
	return instance.post('getgateparamconf.spring', qs.stringify(params)).then(res => res.data)
}




/*
获取首页图层树
*/
export const getlayercontrol = (params) => {
	return instance.post('getlayercontrol.spring', qs.stringify(params)).then(res => res.data)
}
/*
加载地图建筑物点位及基本信息
*/
export const getmapbuildinfo = (params) => {
	return instance.post('getmapbuildinfo.spring', qs.stringify(params)).then(res => res.data)
}
/*
获取视频插件安装包
*/
export const getvideocontrolpackage = (params) => {
	return instance.post('getvideocontrolpackage.spring', qs.stringify(params)).then(res => res.data)
}
/*
数据录入（查询）
*/
export const getrealdata = (params) => {
	return instance.post('getrealdata.spring', qs.stringify(params)).then(res => res.data)
}
/*
数据录入（初整/重整入库）
*/
export const realdata = (params) => {
	return instance.post('realdata.spring', qs.stringify(params)).then(res => res.data)
}
/*
数据录入（肯斯瓦特查询）
*/
export const getrealdatakswt = (params) => {
	return instance.post('getrealdatakswt.spring', qs.stringify(params)).then(res => res.data)
}

/*
数据录入（肯斯瓦特入库）
*/
export const realdatakswt = (params) => {
	return instance.post('realdatakswt.spring', qs.stringify(params)).then(res => res.data)
}


/*
* 取消报警信息
*/
export const updatealarmmessage = (params) => {
	return instance.post('updatealarmmessage.spring', qs.stringify(params)).then(res => res.data)
}
/*
* 查询报警历史记录
*/
export const getalarmhistory = (params) => {
	return instance.post('getalarmhistory.spring', qs.stringify(params)).then(res => res.data)
}





// WEBPACK FOOTER //
// ./src/apis/api.js